export interface UserRegistration {
  username: string;
  password: string;
  registrationToken: string;
}
